import { render, staticRenderFns } from "./WarningPanel.vue?vue&type=template&id=16d8251e&scoped=true"
import script from "./WarningPanel.vue?vue&type=script&lang=js"
export * from "./WarningPanel.vue?vue&type=script&lang=js"
import style0 from "./WarningPanel.vue?vue&type=style&index=0&id=16d8251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d8251e",
  null
  
)

export default component.exports